/**
 * Kliknięcie „Powered by CodiFive” (PRD §10 pkt 62). `keepalive` – żądanie dojdzie, nawet gdy przeglądarka zamknie kartę;
 * błąd ignorujemy, link i tak się otwiera.
 */
export function recordPoweredByClick(): void {
  void fetch('/api/site/powered-by-click', { method: 'POST', credentials: 'same-origin', keepalive: true }).catch(() => undefined);
}
